module.exports = __webpack_public_path__ + "static/media/ai-summit.8a524bf7.jpg";